import { Chart, registerables } from "chart.js";
import { useEffect, useRef } from "react";

Chart.register(...registerables);

const Graficas = () => {
  const areaChartRef = useRef(null);
  const donutChartRef = useRef(null);
  const pieChartRef = useRef(null);
  const lineChartRef = useRef(null);
  const barChartRef = useRef(null);
  const stackedBarChartRef = useRef(null);

  useEffect(() => {
    const createChart = (ctx, type, data, options) => {
      return new Chart(ctx, { type, data, options });
    };

    const chartData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Digital Goods",
          backgroundColor: "rgba(60,141,188,0.9)",
          borderColor: "rgba(60,141,188,0.8)",
          data: [28, 48, 40, 19, 86, 27, 90],
        },
        {
          label: "Electronics",
          backgroundColor: "rgba(210, 214, 222, 1)",
          borderColor: "rgba(210, 214, 222, 1)",
          data: [65, 59, 80, 81, 56, 55, 40],
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
    };

    createChart(areaChartRef.current, "line", chartData, chartOptions);
    createChart(donutChartRef.current, "doughnut", chartData, chartOptions);
    createChart(pieChartRef.current, "pie", chartData, chartOptions);
    createChart(lineChartRef.current, "line", chartData, chartOptions);
    createChart(barChartRef.current, "bar", chartData, chartOptions);
    createChart(stackedBarChartRef.current, "bar", chartData, { ...chartOptions, scales: { x: { stacked: true }, y: { stacked: true } } });
  }, []);

  return (
    <div className="container">
      <div className="row">

        <div className="col-12 col-md-6 mb-4">
          <div className="card card-primary">
            <div className="card-header">Area Chart</div>
            <div className="card-body">
              <canvas ref={areaChartRef}></canvas>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-4">
          <div className="card card-info">
            <div className="card-header">Line Chart</div>
            <div className="card-body">
              <canvas ref={lineChartRef}></canvas>
            </div>
          </div>
        </div>

      </div>

      <div className="row">

          <div className="col-12 col-md-6 mb-4">
          <div className="card card-success">
            <div className="card-header">Stacked Bar Chart</div>
            <div className="card-body">
              <canvas ref={stackedBarChartRef}></canvas>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-4">
          <div className="card card-success">
            <div className="card-header">Bar Chart</div>
            <div className="card-body">
              <canvas ref={barChartRef}></canvas>
            </div>
          </div>
        </div>

      </div>

      <div className="row mt-4">
         <div className="col-12 col-md-6 mb-4">
          <div className="card card-danger">
            <div className="card-header">Pie Chart</div>
            <div className="card-body">
              <canvas ref={pieChartRef}></canvas>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-6 mb-4">
          <div className="card card-danger">
            <div className="card-header">Donut Chart</div>
            <div className="card-body">
              <canvas ref={donutChartRef}></canvas>
            </div>
          </div>
        </div>

      </div>







    </div>
  );
};

export default Graficas;
